module.exports = __webpack_public_path__ + "img/1.1177fd31.png";